import { FeatureDTO } from "./FeatureDTO";

export class ExternalCatalogFeatureDTO extends FeatureDTO {
    constructor(sub?) {
        super(sub);
    }
}